import { useEffect, useState } from 'react';
import { Box, Spinner, Text } from '@chakra-ui/react';

/**
 * Shows the review-and-sign email exactly as the backend will send it (same
 * template, same spacing). Rendered in a sandboxed iframe: no scripts, and
 * links can't navigate.
 */
const EmailPreview = ({ api, sendToName, emailBody }) => {
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        const result = await api.post('/api/pdf/email-preview', {
          sendToName,
          emailBody,
        });
        if (!cancelled) setHtml(result.html);
      } catch (error) {
        console.error('Could not load email preview', error);
      }
      if (!cancelled) setLoading(false);
    }, 400);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendToName, emailBody]);

  return (
    <Box>
      <Text fontSize="xs" fontWeight="bold" color="gray.600" mb={1}>
        EMAIL PREVIEW {loading && <Spinner size="xs" ml={1} />}
      </Text>
      <Box
        as="iframe"
        title="Email preview"
        sandbox=""
        srcDoc={html}
        w="100%"
        h="460px"
        borderWidth="1px"
        borderColor="gray.200"
        borderRadius="md"
        bg="gray.50"
      />
    </Box>
  );
};

export default EmailPreview;
